import { withChartLayout } from 'components/common';
import SavedSystemAssessments from 'components/features/chart/system-assessment/saved-system-assessments/SavedSystemAssessments';

const SavedSystemAssessmentsPage = withChartLayout('Saved System Assessments')(SavedSystemAssessments);
export default SavedSystemAssessmentsPage;
